/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Enum generated from HubAPI C# code.
export enum DiaryTypeEnum {
  None = 0,
  Diary = 1,
  Inspection = 2,
  Dismantle = 3,
  Variation = 4,
  FullHandover = 5,
  PartialHandover = 6,
  FullOffHire = 7,
  PartialOffHire = 8,
  InspectionFollowUpInstruction = 9,
  InspectionFollowUpNotify = 10,
  UnsafeScaffoldReport = 11,
  PauseInspections = 12,
  StopInspections = 13,
  ResumeInspections = 14,
  Adaption = 15,
}
